var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2661_14640",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#333333"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2661_14640)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7778 110C65.5403 110 73.8461 107.769 81.7901 103.099C89.7342 98.4282 96.6465 93.1581 101.432 85.3739C94.9237 80.3141 87.8411 76.5193 80.1842 73.9895C72.5273 71.4596 64.3918 70.1947 55.7778 70.1947C47.1638 70.1947 39.0283 71.4596 31.3714 73.9895C23.7145 76.5193 14.5084 80.5205 8 85.5802C12.7778 93.0123 21.2716 100.444 29.7654 104.16C38.2593 107.877 46.0152 110 55.7778 110ZM55.7778 64.867C61.329 64.867 66.0667 62.8723 69.9909 58.8829C73.9151 54.8935 75.8772 50.0771 75.8772 44.4335C75.8772 38.79 73.9151 33.9735 69.9909 29.9841C66.0667 25.9947 61.329 24 55.7778 24C50.2265 24 45.4888 25.9947 41.5646 29.9841C37.6405 33.9735 35.6784 38.79 35.6784 44.4335C35.6784 50.0771 37.6405 54.8935 41.5646 58.8829C45.4888 62.8723 50.2265 64.867 55.7778 64.867Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9909 58.8829C66.0667 62.8723 61.329 64.867 55.7778 64.867C50.2265 64.867 45.4888 62.8723 41.5646 58.8829C37.6405 54.8935 35.6784 50.0771 35.6784 44.4335C35.6784 38.79 37.6405 33.9735 41.5646 29.9841C45.4888 25.9947 50.2265 24 55.7778 24C61.329 24 66.0667 25.9947 69.9909 29.9841C73.9151 33.9735 75.8772 38.79 75.8772 44.4335C75.8772 50.0771 73.9151 54.8935 69.9909 58.8829Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9909 58.8829C66.0667 62.8723 61.329 64.867 55.7778 64.867C50.2265 64.867 45.4888 62.8723 41.5646 58.8829C37.6405 54.8935 35.6784 50.0771 35.6784 44.4335C35.6784 38.79 37.6405 33.9735 41.5646 29.9841C45.4888 25.9947 50.2265 24 55.7778 24C61.329 24 66.0667 25.9947 69.9909 29.9841C73.9151 33.9735 75.8772 38.79 75.8772 44.4335C75.8772 50.0771 73.9151 54.8935 69.9909 58.8829Z",
    fill: "#333333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutlined);
export default __webpack_public_path__ + "static/media/UserOutlined.a9ae786293a8ddd012d89ca0397f37c2.svg";
export { ForwardRef as ReactComponent };